

let base_url: string = 'https://imake-app.com';

export const environment = {
  production: true,
  ApiEndPoint2: `${base_url}:1116/api`,

};
